// extracted by mini-css-extract-plugin
export default {"App":"App_App__y7Wce","App-logo":"App_App-logo__3MPE4","App-logo-spin":"App_App-logo-spin__Orajh","App-header":"App_App-header__gpbkt","App-link":"App_App-link__m8ozB"};